import {IComponentOptions, IOnChanges, IOnChangesObject} from "angular";
import {BoxPlotChartData} from "../../models/BoxPlotChartData";
import {StringKeyed} from "../../../types/GenericTypes";
import {TechnicalStatistics} from "../../models/TechnicalStatistics";
import {NumberUtil} from "../../../js/util/NumberUtil";

export const TechnicalStatisticsChart = "tfTechnicalStatisticsChart";

export function technicalStatisticsChart(): IComponentOptions {
    return {
        templateUrl: "app/trading-systems/components/technical-statistics-chart/TechnicalStatisticsChartComponent.html",
        bindings: {
            statistics: "<"
        },
        controllerAs: "ctrl",
        controller: TechnicalStatisticsChartComponent
    };
}

export class TechnicalStatisticsChartComponent implements IOnChanges {

    public statistics: TechnicalStatistics;

    public chartOptions: StringKeyed;
    public chartData: BoxPlotChartData;

    public $onChanges(changes: IOnChangesObject): void {
        if (changes["statistics"] != null && this.statistics != null) {
            this.chartOptions = this.initChartOptions(this.statistics);
            this.chartData = this.buildChartData(this.statistics);
        }
    }

    private initChartOptions(statistics: TechnicalStatistics) {
        const low = statistics.yearLow;
        const high = statistics.yearHigh;

        return {
            chart: {
                type: "boxPlotChart",
                height: 245,
                margin : {
                    top: 10,
                    right: 0,
                    bottom: 10,
                    left: 40
                },
                x: (d: any) => d.label,
                maxBoxWidth: 15,
                yDomain: [low, high],
                tooltip: {
                    keyFormatter: (d: any, i: number) => {
                        switch (d) {
                            case "Q1":
                                return "MA Low";
                            case "Q2":
                                return "MA Mid";
                            case "Q3":
                                return "MA High";
                            default:
                                return d;
                        }
                    }
                }
            }
        };
    }

    private buildChartData(statistics: TechnicalStatistics): BoxPlotChartData {
        const Q1 = Math.min(statistics.ma50, statistics.ma200);
        const Q2 = (statistics.ma50 + statistics.ma200) / 2;
        const Q3 = Math.max(statistics.ma50, statistics.ma200);

        const roundedQ2 = NumberUtil.round(Q2, 2);

        return [
            {
                values: {
                    Q1,
                    Q2: roundedQ2,
                    Q3,
                    whisker_low: statistics.yearLow,
                    whisker_high: statistics.yearHigh,
                    outliers: [statistics.price]
                }
            }
        ];
    }
}
